export default __webpack_public_path__ + "static/media/DoctorAndNurse.007ac4f2.svg";